export default __webpack_public_path__ + "static/1-b57369910d41ed758b41a3a1d56cf71c.png";